import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/guards/auth';
import { AcceptInvitePage } from 'src/pages/auth';
import ExtensionAuthPage from 'src/pages/auth/extension-auth-page';
import PasswordResetPage from 'src/pages/auth/password-reset-page';
import AuthModernCompactLayout from 'src/layouts/auth/modern-compact';
import CompleteApplyIntentPage from 'src/pages/external/job-boards/complete-apply-intent-page';
import EmailConnectorCallbackPage from 'src/pages/auth/callbacks/email-connector-callback-page';
import IntegrationCallbackManagerPage from 'src/pages/auth/callbacks/integration-callback-page';
import CompleteConnectIntentPage from 'src/pages/external/job-boards/complete-connect-intent-page';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// JWT
const LoginPage = lazy(() => import('src/pages/auth/login'));
const RegisterRootPage = lazy(() => import('src/pages/auth/register-root'));
const ConfirmAuthorityPage = lazy(() => import('src/pages/auth/organisation-confirm-authority'));
const AccountRegisterPage = lazy(() => import('src/pages/auth/register'));
const VerifyEmailPage = lazy(() => import('src/pages/auth/verify-email-page'));
const RegisterOrganisationPage = lazy(() => import('src/pages/auth/register-organisation-page'));

// ----------------------------------------------------------------------

const children = [
  {
    element: (
      <AuthModernCompactLayout>
        <Outlet />
      </AuthModernCompactLayout>
    ),
    children: [
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'register',
        element: <RegisterRootPage />,
      },
      {
        path: 'register/confirm',
        element: <ConfirmAuthorityPage />,
      },
      {
        path: 'register/account',
        element: <AccountRegisterPage />,
      },
      {
        path: 'register/account/verify',
        element: (
          <AuthGuard>
            <VerifyEmailPage />
          </AuthGuard>
        ),
      },
      {
        path: 'register/organisation',
        element: (
          <AuthGuard>
            <RegisterOrganisationPage />
          </AuthGuard>
        ),
      },
      {
        path: 'password-reset',
        element: <PasswordResetPage />,
      },
      {
        path: 'accept-invite',
        element: <AcceptInvitePage />,
      },
      {
        path: 'callbacks/email-connector',
        element: <EmailConnectorCallbackPage />,
      },
      {
        path: 'callbacks/:provider',
        element: <IntegrationCallbackManagerPage />,
      },
      {
        path: 'apply-intent/complete-registration',
        element: <CompleteApplyIntentPage />,
      },
      {
        path: 'connect-intent/complete-registration',
        element: <CompleteConnectIntentPage />,
      },
    ],
  },
  {
    path: 'extension',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <AuthGuard>
          <AuthModernCompactLayout>
            <ExtensionAuthPage />
          </AuthModernCompactLayout>
        </AuthGuard>
      </Suspense>
    ),
  },
];

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children,
  },
];
